<template>
  <modal :name="modalName" :width="520">
    <div>
      <header class="modal-header center-md center-xs py15 px65 h3 sans-serif weight-700 bg-cl-secondary flex">
        <span>{{ $t('Verify phone number') }}</span>
        <i slot="close" class="modal-close material-icons p15 cl-bg-tertiary" @click="close" data-testid="closeModalButton">
          close
        </i>
      </header>
      <div class="modal-content verify-phone-number">
        <form @submit.prevent="verifyPhoneNumber" novalidate>
          <base-input
            type="text"
            name="sms-verification-code"
            class="mb10"
            v-model="verificationCode"
            @blur="$v.verificationCode.$touch()"
            :placeholder="$t('Verification Code')"
            :validations="[
              {
                condition: !$v.verificationCode.required && $v.verificationCode.$error,
                text: $t('Field is required.')
              },
              {
                condition: !$v.verificationCode.minLength,
                text: $t('Code consists of 4 digits')
              }
            ]"
          />
          <div class="center-md center-xs">
            <timer @endTimer="enableSendNewSMS = true"/>
            <div :class="{'disabled': !enableSendNewSMS}" class="send-sms" @click="sendSMSAgain">{{ $t('Resend code') }}</div>
          </div>
          <button-full class="mb20" type="submit">
            {{ $t('Verify') }}
          </button-full>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from 'theme/components/core/Modal'
import ButtonFull from 'theme/components/theme/ButtonFull'
import { required, minLength } from 'vuelidate/lib/validators'
import i18n from '@vue-storefront/i18n'
import Timer from "./Timer";

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  name: 'VerifyPhoneNumberModal',
  components: {
    Modal,
    ButtonFull,
    BaseInput,
    Timer
  },
  validations: {
    verificationCode: {
      required,
      minLength: minLength(4)
    }
  },
  props: {
    phone: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      verificationCode: '',
      modalName: 'verify-phone-number',
      enableSendNewSMS: false
    }
  },
  mounted () {
    this.$bus.$on('request-verify-phone-number', this.request)
  },
  methods: {
    ...mapActions({
      requestVerification: 'user/requestPhoneVerification',
      verify: 'user/verifyPhoneNumber'
    }),
    request () {
      let phone = this.phone ? this.phone : null
      this.requestVerification(phone)
    },
    verifyPhoneNumber () {
      if (!this.verificationCode || this.verificationCode.length < 4) {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: i18n.t('Verification code is not correct'),
          action1: { label: i18n.t('OK') }
        })
        return
      }
      this.verify(this.verificationCode)
        .then(result => {
          let resMessage = result.result && result.result.message ? result.result.message : result.result
          let message = resMessage ? resMessage : 'Verification code is not correct'
          let status = result.result.status ? result.result.status : 'error'
          if (result.code == 400) {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message: i18n.t(message),
              action1: { label: i18n.t('OK') }
            })
            return
          }
          this.$store.dispatch('notification/spawnNotification', {
            type: status,
            message: i18n.t(message),
            action1: { label: i18n.t('OK') }
          })
          this.close(result)
        })
        .catch(error => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: i18n.t('Something went wrong'),
            action1: { label: i18n.t('OK') }
          })
          console.error(error)
        })
    },
    close (result) {
      let isSuccess = false
      if (result.result && result.result.status == 'success') {
        isSuccess = true
      }
      this.$bus.$emit('modal-hide', this.modalName)
      this.$emit("closeVerifyPhoneModal", isSuccess)
    },
    sendSMSAgain () {
      if (this.enableSendNewSMS) {
        let phone = this.phone ? this.phone : null
        this.requestVerification(phone)
        this.$bus.$emit('start-timer', 300)
        this.enableSendNewSMS = false
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('request-verify-phone-number', this.request)
  }
}
</script>

<style lang="scss" scoped>
  .centered-button {
    margin: 0 auto;
  }

  @media only screen and (max-width: 600px) {
    .modal-header span {
      margin-top: 20px;
    }
  }
  .verify-phone-number {
    padding: 25px;
    padding-bottom: 5px;
  }
  .send-sms {
    text-decoration: underline;
    text-align: center;
    margin-bottom: 30px;
    color: #11bb2e;
    cursor: pointer;
  }
  .disabled {
    color: gray;
    cursor: grab;
  }
</style>
